import React from 'react';

import LanguageSelector from 'app/components/LanguageSelector/LanguageSelector';
import Text from 'app/components/layout/Text.styled';
import S from 'app/features/footer/components/Footer.styled';
import PrivacyPolicyLink from 'app/features/footer/components/PrivacyPolicyLink';
import TermsOfServiceLink from 'app/features/footer/components/TermsOfServiceLink';
import GenderIndex from 'app/features/footer/components/GenderIndex';
import ModernSlavery from 'app/features/footer/components/ModernSlavery';
import DoNotSell from 'app/features/footer/components/DoNotSell';
import CookieConsent from 'app/features/footer/components/CookieConsent';
import AdChoices from 'app/features/footer/components/AdChoices';
import EvidonRefreshHotfix from 'app/features/footer/components/EvidonRefreshHotfix';
import ErrorBoundary from 'app/components/errorPages/ErrorBoundary';

const Footer = () => (
  <S.Footer>
    <S.FooterTopRow>
      <S.LinksWrapper>
        <ErrorBoundary>
          <EvidonRefreshHotfix />
        </ErrorBoundary>
        <TermsOfServiceLink />
        <PrivacyPolicyLink />
        <CookieConsent />
        <S.FlexDivider />
        <AdChoices />
        <DoNotSell />
        <GenderIndex />
        <ModernSlavery />
      </S.LinksWrapper>
    </S.FooterTopRow>
    <S.FooterBottomRow>
      <Text size="l" type="semibold" as={S.Footer.Copyright}>
        © Ellation, LLC
      </Text>
      <LanguageSelector />
    </S.FooterBottomRow>
  </S.Footer>
);

export default Footer;
